import * as React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

import { UnscrollableContainer } from '../../misc';
import {
  Container,
  ColumnOne,
  ColumnTwo,
  ColumnOneContent,
  ContentTitle,
  ContentSubTitle,
  ContentCTOs,
  ImageOne,
  ImageTwo,
  ImageThree,
  MobileViewCarousel,
  LoginCTO,
} from './styles';
import stdImgOne from '../../assets/std1.jpeg';
import stdImgTwo from '../../assets/std2.webp';
import stdImgThree from '../../assets/std3.jpg';
import { Modal, PageHeader } from '../../components';
import { InvigilatorLoginForm, StudentLoginForm } from './components';
import { Helmet } from 'react-helmet';

export const LandingPage = (): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [user, setUser] = React.useState<string>('');

  const toggleModal = (): void => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <UnscrollableContainer>
      <Helmet>
        <title>KNUST, CoE Check timetable</title>
        <meta
          name="check-timetable"
          content="Sign in page for KNUST,college of engineering students and 
          invigilators to check timetable schedule"
        />
      </Helmet>
      <Container>
        <ColumnOne>
          <PageHeader />
          <MobileViewCarousel>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            <Carousel
              showArrows={false}
              showThumbs={false}
              autoPlay
              infiniteLoop
              showStatus={false}
            >
              {/* Using ImageOne styles for all the carousel images */}
              <div>
                <ImageOne src={stdImgThree} />
              </div>
              <div>
                <ImageOne src={stdImgTwo} />
              </div>
              <div>
                <ImageOne src={stdImgOne} />
              </div>
            </Carousel>
          </MobileViewCarousel>
          <ColumnOneContent>
            <ContentTitle style={{ wordSpacing: '10px' }}>How prepared are you?</ContentTitle>
            <ContentSubTitle>Please log in to access your timetable</ContentSubTitle>
            <ContentCTOs>
              <LoginCTO
                onClick={() => {
                  toggleModal();
                  setUser('student');
                  localStorage.setItem('coe-current-user', 'student');
                }}
              >
                <span>Student login</span> <i className="ml-2 mt-1 fas fa-angle-right" />
              </LoginCTO>
              <LoginCTO
                onClick={() => {
                  toggleModal();
                  setUser('invigilator');
                  localStorage.setItem('coe-current-user', 'invigilator');
                }}
              >
                <span>Invigilator login</span> <i className="ml-2 mt-1 fas fa-angle-right" />
              </LoginCTO>
            </ContentCTOs>
          </ColumnOneContent>
        </ColumnOne>
        <ColumnTwo style={{ backgroundColor: ' #CFCFD3' }}>
          <ImageOne src={stdImgOne} />
          <ImageTwo src={stdImgTwo} />
          <ImageThree src={stdImgThree} />
        </ColumnTwo>
      </Container>
      <Modal modalIsOpen={isModalOpen} toggleModal={toggleModal}>
        {user === 'student' ? (
          <StudentLoginForm toggleModal={toggleModal} />
        ) : (
          <InvigilatorLoginForm toggleModal={toggleModal} />
        )}
      </Modal>
    </UnscrollableContainer>
  );
};
